import type { Calendar } from "../Models/Domain";
import type { CalendarApi } from "../Models/Api";

import { getCalendars } from "@/Services/TherapyApi/Calendars";
import CalendarTransformer from "@/Modules/Transformers/Calendars/Calendar";

import useCalendarStore from "../Store";
import useUserStore from "@/Modules/User/Store";

const fetchCalendarsActionHandler = async (): Promise<Calendar[]> => {
  const calendarStore = useCalendarStore();
  const userStore = useUserStore();

  if (userStore.getUserIsPatient) {
    calendarStore.calendars = [
      {
        uuid: "d61483d7-1714-47f7-996f-a57a99aeb873",
        created_at: 1740400427,
        type: "native",
        name: "therapyside",
        description: "Therapyside",
        background_color: "#CBE6FA",
        foreground_color: "#000000",
        time_zone: "Europe/Madrid",
        can_overlap: true,
        duration: null,
        is_enabled: true,
        is_default: true,
      } as CalendarApi,
    ].map((calendar) => CalendarTransformer.toDomain(calendar));
  } else {
    const resp = await getCalendars();

    calendarStore.calendars = resp.map((calendar) => CalendarTransformer.toDomain(calendar));
  }

  return calendarStore.calendars;
};

export default fetchCalendarsActionHandler;
